import React, { Component } from 'react';
import ReactCustomFlagSelect from './ReactCustomFlagSelect';
import { ToastContainer, toast } from 'react-toastify';
import CollectJSSection from "./CollectJSSection";
import LotDetails from './LotDetails';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
// import 'moment-timezone';
import { countryCode, getStripeError } from './static';
import './App.css';
import gpsIcon from "./img/gps.png";
import googleIcon from "./img/google-play.png";
import iosIcon from "./img/ios-appstore.png";
import notAllowed from "./img/exclamation-mark.png";

export default class App extends Component {

  constructor(props){
    super(props);
    this.initForm = this.initForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAreaCode = this.handleAreaCode.bind(this);
    this.handleSpotChange = this.handleSpotChange.bind(this);
    this.authorizePayment = this.authorizePayment.bind(this);
    this.hours = [];
    this.mins = [];
    this.env = process.env.REACT_APP_ENVIRONMENT;
    this.oversizeMsgLotList = [5742];
    const urlParams = new URLSearchParams(window.location.search);
    if(this.env === 'STAGING' && urlParams && urlParams.get('env') && urlParams.get('env') === 'dev'){
      this.baseUrl = process.env.REACT_APP_DEV_API_URL;
      this.stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY;
    }else{
      this.baseUrl = process.env.REACT_APP_API_URL;
      this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    }
    for(let i=0; i <= 1440; i++){
      this.hours.push({
          value: i,
          display: i + ' Hr'
      })
    }
    for(let j=0; j < 60; j+=5){
      if(j < 10){
        this.mins.push({
          value: j,
          display: '0' + j + ' mins'
        })
      }else{
        this.mins.push({
          value: j,
          display: j + ' mins'
        })
      }
    }
    this.initialState =  {
      parkingType:'',
      showWarning: false,
      isTimingDisabled: true,
      loading: false,
      isPaymentProcessing: false,
      booked: false,
      seeMore: false,
      isSaveProfile: true,
      fields: {
        areaCode: 1,
        hours: 0,
        mins: 0,
        email: ''
      },
      errors: {}
    }
    this.resetState = {
      parkingType: '',
      showWarning: false,
      booked: true,
      isTimingDisabled: true,
      isSaveProfile: true,
      bookingID: null,
      convenienceFee: null,
      end: null,
      errors: {},
      fields: {areaCode: 1, hours: 0, mins: 0, spot_no: '', email: '', license_plate: '', mobile: '', hours: '', mins: '', zip: '', cardholder_name: '', coupon: ''},
      loading: false,
      isPaymentProcessing: false,
      parkingFee: null,
      slotId: null,
      totalFee: null,
      couponApplied: false,
      discountAmount: 0
    }
    this.state = this.initialState;
  }

  componentDidMount(){
    const defer = () =>  {
      if (window.CollectJS) {
          this.initForm(this);
      } else {
          setTimeout(function() { defer ()  }, 50);
      }
    }
    this.refreshAfterSleep();
    defer();
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
	}

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  getArena(){
    const urlParams = new URLSearchParams(window.location.search);
    fetch(`${this.baseUrl}/pay/arena/details?arena_hash=${urlParams.get('id')}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            const start = moment().format('MMM DD, YYYY, hh:mm A');
            const isShowOversizeMsg = this.oversizeMsgLotList.includes(resp.data.parking_id);
            this.setState({ 
              arenaDetails: resp.data && resp.data.pricing ? resp.data : null, 
              parkingId: resp.data.parking_id,
              name: resp.data.name,
              start: start,
              end: moment(start, 'MMM DD, YYYY, hh:mm A').add(resp.data.default_hour, 'hours').format('MMM DD, YYYY, hh:mm A'),
              fields: {
                ...this.state.fields,
                hours: resp.data.default_hour
              },
              isWithSlot: resp.data.with_slots ? true : false,
              fixedSlotId: resp.data.with_slots ? '' : resp.data.slot_id,
              parkingFee: resp.data.parking_fee,
              convenienceFee: resp.data.convenience_fee,
              totalFee: resp.data.parking_charge,
              isShowOversizeMsg
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  validateCoupon(){
    let couponApplyBtn = document.querySelector('.coupon-apply');
    couponApplyBtn.disabled = true;
    if(this.state.couponApplied){
      this.calculatePrice();
      couponApplyBtn.disabled = false;
      return;
    }
    let {start, end, parkingFee, convenienceFee, totalFee, parkingId, fields} = this.state;
    if(!start || !end || !parkingFee || !convenienceFee || !totalFee || !parkingId || !fields.coupon){
      couponApplyBtn.disabled = false;
      return;
    } 

    this.setState({loading : true});
    const startDateTime = moment(start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const endDateTime = moment(end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    let request = {
      "start_date_time": startDateTime,
      "end_date_time": endDateTime,
      "coupon_code": this.state.fields['coupon'],
      "parking_charge": totalFee,
      "parking_fee": parkingFee,
      "convenience_fee": convenienceFee,
      "parking_id": parkingId
    };
    fetch(`${this.baseUrl}/coupons`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.coupon_detail){
            const hasKeys = !!Object.keys(resp.data.coupon_detail).length;
            if(hasKeys){
              let cd = resp.data.coupon_detail;
              this.setState({
                couponApplied: true,
                parkingFee: cd.parking_fee,
                convenienceFee: cd.convenience_fee,
                totalFee: cd.payable_amount,
                discountAmount: cd.discount_amount,
                loading: false
              }, () =>  couponApplyBtn.disabled = false)
            }else{
              this.setState({loading : false});
              toast.dismiss();
              toast.error('Invalid coupon');
              couponApplyBtn.disabled = false;
            }
          }else{
            let fields = this.state.fields;
            fields["coupon"] = '';
            this.setState({
              couponApplied: false,
              discountAmount: 0,
              fields,
              loading: false
            }, () =>  couponApplyBtn.disabled = false)  
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.dismiss();
            toast.error(errMsg, { autoClose: resp.error && resp.error.reason ? 10000 : 2000 });
          }
        })
        .catch((error) => {
          this.setState({loading : false}, () =>  couponApplyBtn.disabled = false)
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  calculatePrice(){
    const start = moment(this.state.start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const end = moment(this.state.end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const spotNo = this.state.fields['spot_no'];
    if(!start || !end || (!spotNo && this.state.isWithSlot)) return;
    fetch(`${this.baseUrl}/pay/parking/slot/details?start_date_time=${start}&end_date_time=${end}&parking_id=${this.state.parkingId}&slot_name=${spotNo && spotNo.length === 1 ? '0' + spotNo : spotNo ? spotNo : ''}&slot_id=${!this.state.isWithSlot ? this.state.fixedSlotId : null}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
                let fields = this.state.fields;
                fields["coupon"] = '';
                this.setState({ 
                  slotId: this.state.isWithSlot ? resp.data.slot_id : this.state.fixedSlotId,
                  parkingFee: resp.data.parking_fee,
                  convenienceFee: resp.data.convenience_fee,
                  totalFee: resp.data.parking_charge,
                  showWarning: resp.data.restricted_message ? true : false,
                  warningMsg: resp.data.restricted_message ? resp.data.restricted_message : '',
                  parkingType: resp.data.parking_type,
                  couponApplied: false,
                  discountAmount: 0,
                  fields
                })  
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            let fields = this.state.fields;
            fields["coupon"] = '';
            fields["spot_no"] = ''; 
            this.setState({
              fields,
              parkingFee: null,
              convenienceFee: null,
              totalFee: null,
              couponApplied: false,
              discountAmount: 0
            }, () => {
              toast.dismiss();
              toast.dismiss();
              toast.error(errMsg, {autoClose: 2000});
            })
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error('Something went wrong');
        });
   }

  getLotTZ(id){
    let timeZone = '';
    switch (id) {
      // san antonio
      case 5705:
        timeZone = 'US/Central';
        break;
      // miami  
      case 5706:
      case 5707:  
        timeZone = 'US/Eastern';
        break;
      default:
        break;
    }
    return timeZone;
  }

  handleAreaCode(areaCode){
    let fields = {...this.state.fields};
    fields['areaCode'] = areaCode;
    this.setState({ 
      fields 
    });
  }

  debounce(func, timeout = 10){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { 
        func.apply(this, args);
      }, timeout);
    };
  }

  handleSpotChange(e){
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value ? e.target.value.trim() : '';
    const isInValid = !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(fields[e.target.name]);
    if(!isInValid) return;
     
    this.setState({
        fields,
        isTimingDisabled: fields[e.target.name].length ? false : true
      }, () => {
        if((this.state.fields['hours'] || this.state.fields['mins']) && this.state.fields['spot_no'] && this.state.fields['spot_no'].length){
          /* const processChange = this.debounce(() => this.calculatePrice());
          processChange(); */
          let duration = 1000;
          clearTimeout(this.inputTimer);
          this.inputTimer = setTimeout(()=>{
            this.calculatePrice();
          }, duration);  
        }
    });
  }

  handleChange(e) {
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value;
    if(e.target.name === 'hours' || e.target.name === 'mins'){
      this.setState({
        fields
      }, () => {
        this.setState({
          end: moment(this.state.start, 'MMM DD, YYYY, hh:mm A').add(this.state.fields['hours'], 'hours').add(this.state.fields['mins'], 'minutes').format('MMM DD, YYYY, hh:mm A')
        }, () => { if((this.state.fields['spot_no'] && this.state.fields['spot_no'].length) || !this.state.isWithSlot) this.calculatePrice()});
      });
    }else{
      this.setState({
          fields
        });
    }
    
  }

  nonSpecialCharacter(name){
      let fields = this.state.fields;
      return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(fields[name]);
  }

  onlyZip(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]{5}$/)){
      return false;
    }
    return true;
  }

  onlyPhone(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]*$/)){
      return false;
    }
    return true;
  }

  onlyEmail(name){
    let fields = this.state.fields;
    if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
      return false;
    }
    return true;
  }

  initForm(){
    this.getArena();
    window.CollectJS.configure({
      variant: 'inline',
      styleSniffer: true,
      callback: (token) => {
        console.log("callback", JSON.stringify(token));
        this.authorizePayment(token)
      },
      validationCallback : (field, status, message) => {
        if (status) {
            var message = field + " is now OK: " + message;
            this.setState({
              [field]: false
            })
        } else {
          this.setState({
            [field]: true
          })
        }
        console.log(message);
      },
      "customCss" : {
        "color": "#000",
        "background-color": "#fff",
        "border-radius": '10px',
        "padding": '0 10px',
        "display": "block",
        "border": 'none',
        "line-height": '40px',
        "height": '40px'
      },
      "invalidCss": {
          "border": "1px solid red"
      },
      "validCss": {
          "border": 'none'
      },
      "placeholderCss": {
      },
      "focusCss": {
      },
      fields: {
        ccnumber: {
          placeholder: 'Card Number',
          selector: '#ccnumber'
        },
        ccexp: {
          placeholder: 'MM/YY',
          selector: '#ccexp'
        },
        cvv: {
          placeholder: 'CVC',
          selector: '#cvv'
        }
      }
    });
  }

  find(search, keys){
    if(!search) {
      return {
        "id": "1",
        "name": "US",
        "displayText": "United States (+1)",
        "country": "United States",
        "locale": "",
        "flag": `${URL.S3_BUCKET2}/FlagKit/US.imageset/US.png`
      }
    }
    var lowSearch = search.toLowerCase();
    return countryCode.filter(function(item){
        return keys.some( key => 
            String(item[key]).toLowerCase().includes(lowSearch) 
        );
    });
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  handleFocusSp(name){
    document.querySelector(`select[name="${name}"]`).focus();
    return false;
  }

  handleClose(){
    this.setState({booked: false, bookedID: null }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleErrorModalClose(){
    this.setState({payErrorMsg: false }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleProfile(){
    this.setState({
      isSaveProfile: !this.state.isSaveProfile
    })
  }

  handleSeeMore(){
    this.setState({seeMore: !this.state.seeMore }, () => {
      this.manageBodyBackground(this.state.seeMore);
    })
  }

  handleEmptySlot(){
    if(!this.state.isTimingDisabled || !this.state.isWithSlot) return;
    toast.dismiss();
    toast.error('Please enter spot no.');
  }

  hideWarningModal(e, isClearSlot){
    if(isClearSlot){
      let fields = this.state.fields;
      fields["spot_no"] = ''; 
      this.setState({
        slotId: '',
        fields,
        showWarning: false,
        warningMsg: '',
        parkingFee: '',
        convenienceFee: '',
        totalFee: '',
        parkingType: ''
      })
    }else{
      this.setState({
        showWarning: false,
        warningMsg: ''
      })
    }
  }

  openErrorModal(payErrorMsg){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.manageBodyBackground(true);
    this.setState({payErrorMsg});
  }

  validateForm(isCard){
    let fields = this.state.fields;
    let formIsValid = true;
    this.errors = {};
    let isPayment = this.state.couponApplied && this.state.totalFee === 0 ? false : true;
    if (this.state.isWithSlot && (!fields["spot_no"] || (fields["spot_no"] && fields["spot_no"].trim() === ''))) {
      formIsValid = false;
      this.errors["spot_no"] = "enter a spot no.";
    }
    if (!fields["license_plate"] || (fields["license_plate"] && fields["license_plate"].trim() === '')) {
      formIsValid = false;
      this.errors["license_plate"] = "enter your license plate no.";
    }
    if (typeof fields["license_plate"] !== "undefined") {
      const isValid = this.nonSpecialCharacter("license_plate");
      if (!isValid) {
        formIsValid = false;
        this.errors["license_plate"] = "enter a valid license plate no.";
      }
    }
    if (!fields["mobile"] || (fields["mobile"] && fields["mobile"].trim() === '')) {
      formIsValid = false;
      this.errors["mobile"] = "enter your mobile no.";
    }
    if (typeof fields["mobile"] !== "undefined") {
      const isValid = this.onlyPhone("mobile");
      if (!isValid) {
        formIsValid = false;
        this.errors["mobile"] = "enter a valid mobile no.";
      }
    }

    if (fields["email"] != '' && fields["email"].trim() != '') {
      const isValid = this.onlyEmail("email");
      if (!isValid) {
        formIsValid = false;
        this.errors["email"] = "enter a valid email address";
      }
    }

    if ((!fields["hours"] || fields["hours"] == 0) && (!fields["mins"] || fields["mins"] == 0)) {
      formIsValid = false;
      this.errors["duration"] = "select the parking duration";
    }

    if(this.state.ccnumber || this.state.ccexp || this.state.cvv){
      formIsValid = false;
      this.errors["card_details"] = "invalid card details, check card number/expiry/cvv";
    }

    this.setState({
      errors: this.errors
    });
    return formIsValid;
  }

  preSubmit(){
    document.getElementById("pay-submit").disabled =  true;
    if(this.state.isPaymentProcessing) return;
    const submitBtn = document.getElementById("pay-submit");
    const isValid = this.validateForm(true);
    if(!isValid) {
      submitBtn.disabled = false;
      return;
    }
    
    let isPayment = this.state.couponApplied && this.state.totalFee === 0 ? false : true;
    if(isPayment && !this.state.totalFee){
      toast.dismiss();
      toast.error('Please enter valid spot no. & duration');
      submitBtn.disabled = false;
      return;
    }
    this.manageBodyBackground(true);
    this.setState({isPaymentProcessing : true});
    if(isPayment){
      const { fields } = this.state;
      let contactNumber = fields.mobile ? fields.mobile.trim() : '';
      let countryCode = fields.areaCode ? '+' + fields.areaCode : '';
      var options = {
        name: fields.cardholder_name,
        phone: countryCode +' '+ contactNumber
      };
      if(fields.email){
        options.email = fields.email ? fields.email.trim() : ''
      }
      let req = {
        type: 'card',
        card: this.card,
        billing_details: {
          name: fields.cardholder_name,
          phone: countryCode +' '+ contactNumber
        }
      }
      window.CollectJS.startPaymentRequest();
    }else{
      this.handleSubmit('');
    }
  }

  authorizePayment(data){
    let payErrorMsg = '';
    const submitBtn = document.getElementById("pay-submit");
    const request = {
      ...data,
      amount: this.state.totalFee,
      cardholder_name: this.state.fields.cardholder_name 
    }
    fetch(`${this.baseUrl}/parking/nmi/payments`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          this.handleSubmit(resp.data.transactionid);
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({isPaymentProcessing : false});
          payErrorMsg = getStripeError(errMsg);
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
          this.manageBodyBackground(false);
          this.setState({isPaymentProcessing : false});
          payErrorMsg = getStripeError('');
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
      })  
  }

  prepareRequest(id, paymentMethodId, customerId, paymentIntent, chargeId, walletType){
    const { fields } = this.state;
    const countryCodeName = countryCode.filter(item => item.id == fields.areaCode)[0]; 
    const start = moment(this.state.start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const end = moment(this.state.end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const request = {
      apple_pay: walletType === 'applePay' ? true : false,
      google_pay: walletType === 'googlePay' ? true : false,
      transaction_id: id ? id : '',
      email: fields.email ? fields.email.trim() : '',
      contact_number: fields.mobile ? fields.mobile.trim() : '',
      country_code: fields.areaCode ? '+' + fields.areaCode : '',
      country_name: countryCodeName ? countryCodeName.name : '',
      vehicle_no: fields.license_plate ? fields.license_plate.toUpperCase().trim() : '',
      start_date_time: start,
      end_date_time: end,
      parking_arena_id: this.state.parkingId,
      slot_id: this.state.isWithSlot ? this.state.slotId : this.state.fixedSlotId,
      cardholder_name: fields["cardholder_name"] ? fields["cardholder_name"] : '',
      save_profile: this.state.isSaveProfile,
      coupon_code: fields.coupon ? fields.coupon : '',
      nmi: true,
      payment_method_id: paymentMethodId ? paymentMethodId : '',
      payment_details: { 
        customer: customerId ? customerId : '',
        payment_intent: paymentIntent ? paymentIntent : '',
        charge_id: chargeId ? chargeId : ''
      }
    }
    return request;
  }

  handleSubmit(id){
    let payErrorMsg = '';
    const submitBtn = document.getElementById("pay-submit");
    let request = this.prepareRequest(id);
    fetch(`${this.baseUrl}/pay/parking/reserve`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          window.scrollTo(0,0);
          this.setState({...this.resetState, bookingID: resp.data.booking_id}, () => {
            this.getArena();
            submitBtn.disabled = false;
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({isPaymentProcessing : false});
          payErrorMsg = getStripeError(errMsg);
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.manageBodyBackground(false);
        this.setState({isPaymentProcessing : false});
        payErrorMsg = getStripeError('');
        this.openErrorModal(payErrorMsg);
        submitBtn.disabled = false;
      });  
  }

  render() {
    let isPayment = this.state.couponApplied && this.state.totalFee === 0 ? false : true;
    return (
      <div style={{position: 'relative'}}>
        {(this.state.loading || this.state.isPaymentProcessing  || this.state.payErrorMsg) && <div className='loader-background'></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        {this.state.isPaymentProcessing && 
          <div className="loader-v2">
            <div className='spinner'></div>
            <p>Please do not refresh this page or press back button while we are processing your payment.</p>
          </div>}
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span>
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Booked Successfully</h3>
          <div className="success-message__content">
              <p>Booking Id: {this.state.bookingID}</p>
          </div>
        </div>
        
        <div style={{display: this.state.showWarning ? 'block' : 'none'}} className="success-message">
          {this.state.parkingType === 'restricted' && <span onClick={this.hideWarningModal.bind(this, true)} id="sm-close">&times;</span>} 
          <div style={{textAlign: 'center'}}>
            <img style={{height: 55}} src={notAllowed} /> 
          </div>
          <h4 style={{color: '#000'}} className="success-message__title">{this.state.warningMsg}</h4>
          {this.state.parkingType === 'limited' && <div style={{transform: `translateY(35px)`}}>
            <button style={{marginRight: '25px'}} className="limited-rule-btn1" onClick={this.hideWarningModal.bind(this)}>Proceed</button>
            <button className="limited-rule-btn2" onClick={this.hideWarningModal.bind(this, true)}>Cancel</button>
          </div>}
        </div>
        <div style={{display: this.state.payErrorMsg ? 'block' : 'none'}} className="error-message">
          <span onClick={this.handleErrorModalClose.bind(this)} id="sm-close">&times;</span>
          <svg fill="#FF0000" viewBox="0 0 478.125 478.125" xmlSpace="preserve" className="error-message__icon icon-checkmark">
            <g>
              <g>
                <g>
                  <circle cx="239.904" cy="314.721" r="35.878" />
                  <path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9
                  c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z" />
                  <path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062
                  S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595
                  s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z" />
                </g>
              </g>
            </g>
          </svg>
          <div className="error-message__content">
             <p>{this.state.payErrorMsg}</p>
          </div>
        </div>
        {this.state.seeMore && this.state.arenaDetails && <div className="lot-details">
          <span onClick={this.handleSeeMore.bind(this)} id="sm-close">&times;</span>
          <LotDetails details={this.state.arenaDetails} />
        </div>}
        <form style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto'}} action="#" method="POST">
          <input type="hidden" name="token" />
          <div style={{textAlign: 'center', paddingBottom: 20}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>
          <div style={{textAlign: 'center'}} className="location">
            <img style={{height: 35}} src={gpsIcon} /> 
            <span>{this.state.name}</span>
          </div>
          {this.state.isWithSlot && <div className="upper">
            <span onClick={() => this.handleFocus('spot_no')}>To get started, please tell us the spot no. you are parked on  <i>*</i></span>
            <input
              id="spot_no"
              className="pay-fields" 
              value={this.state.fields["spot_no"]}
              style={{textTransform: 'uppercase'}}
              name="spot_no"
              onChange={this.handleSpotChange}
              maxLength={4}
            />
            <div className="error-msg">{this.state.errors['spot_no']}</div>
          </div>}
          <div className="upper">
            <span onClick={() => this.handleFocus('license_plate')}>{this.state.isWithSlot ? 'Now, give us the license plate no.' :  'To get started, please tell us the license plate no.'} <i>*</i></span>
            <input
              className="pay-fields" 
              style={{textTransform: 'uppercase'}}
              value={this.state.fields["license_plate"]}
              name="license_plate"
              onChange={this.handleChange}
              maxLength={10}
            />
            <div style={{fontSize: '12px', color: '#afafaf', maxWidth: '406px'}}>{this.state.isShowOversizeMsg ? <>Inaccurate License Plate number will result in  monetary fine.<br/> Oversized vehicles not allowed. Can be towed at owner's risk and expense.</> : "Inaccurate License Plate number will result in  monetary fine."}</div>
            <div className="error-msg">{this.state.errors['license_plate']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('email')}>Next, provide your email address. We will send you the receipt.</span>
            <input
              className="pay-fields" 
              value={this.state.fields["email"]}
              name="email"
              onChange={this.handleChange}
              maxLength={150}
            />
            <div className="error-msg">{this.state.errors['email']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('mobile')}>Enter your mobile no. to get updates <i>*</i></span>
            <div className="country-with-phone">
              <div className="country-code">
                  <ReactCustomFlagSelect
                    showSearch={false} 
                    showArrow={true} 
                    animate={true} 
                    value={this.state.fields['areaCode']}
                    customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                    optionList={countryCode} 
                    onChange={areaCode => {
                      this.handleAreaCode(areaCode);
                    }}
                    
                  />
              </div>
              <div className="input-wrapper">
                  <input
                    className="pay-fields mobile-input" 
                    value={this.state.fields["mobile"]}
                    name="mobile"
                    onChange={this.handleChange}
                    maxLength={15}
                  />
              </div>
              <div style={{clear: 'both'}}></div>
            </div>
            <div style={{fontSize: '12px', color: '#000'}}>By entering your mobile no, you are giving us the consent to send you updates regarding this reservation via SMS.</div>
            <div className="error-msg">{this.state.errors['mobile']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocusSp('hours')}>And lastly, select the duration you need this spot for <i>*</i></span>
            {/* <input
              className="pay-fields" 
              value={this.state.fields["duration"]}
              name="duration"
              onChange={this.handleChange}
            /> */}
            <div className="pay-duration">
              <span onClick={this.handleEmptySlot.bind(this)}>
                <select disabled={this.state.isWithSlot && this.state.isTimingDisabled} name="hours" value={this.state.fields["hours"]} onChange={this.handleChange}>
                  {this.hours.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                </select>
              </span>
              <span onClick={this.handleEmptySlot.bind(this)}>
                <select disabled={this.state.isWithSlot && this.state.isTimingDisabled} name="mins" value={this.state.fields["mins"]} onChange={this.handleChange} style={{marginLeft: '20px'}}>
                  {this.mins.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                </select>
              </span>
              <div style={{clear: 'both'}}></div>
            </div>
            <div className="error-msg">{this.state.errors['duration']}</div>
          </div>
          {this.state.arenaDetails && <div style={{padding: '5px 0'}}>
            <span style={{color: 'rgb(220, 110, 125)', cursor: 'pointer'}} onClick={this.handleSeeMore.bind(this)}>See more</span>
          </div>}
          <h4 style={{paddingTop: 10, paddingBottom: 10}}>Reservation Summary</h4>
          <ul className="pay-timings">
            <li>
              <span className="list-initial">Start time</span>
              <span>{this.state.start}</span>
            </li>
            <li>
              <span className="list-initial">End time</span>
              <span>{this.state.end}</span>
            </li>
            <li>
              <span className="list-initial">Parking fee</span>
              <span>{this.state.parkingFee > -1 ? `$${(this.state.parkingFee/100).toFixed(2)}` : ''}</span>
            </li>
            <li>
              <span className="list-initial">Convenience fee</span>
              <span>{this.state.convenienceFee > -1 ? `$${(this.state.convenienceFee/100).toFixed(2)}` : ''}</span>
            </li>
            {this.state.discountAmount > 0 && <li>
              <span className="list-initial">Discount amount</span>
              <span>{this.state.parkingFee > -1 ? `$${(this.state.discountAmount/100).toFixed(2)}` : ''}</span>
            </li>}
            <li>
              <span className="list-initial">Total fee</span>
              <span style={{fontWeight: 600, fontSize: '18px'}}>{this.state.totalFee > -1 ? `$${(this.state.totalFee/100).toFixed(2)}` : ''}</span>
            </li>
          </ul>
          <div style={{position: 'relative'}} class="upper">
            <span onClick={() => this.handleFocus('coupon')} style={{fontWeight: 'bold', fontSize: '14px'}}>Apply Coupon</span>
            <div onClick={this.handleEmptySlot.bind(this)}>
              <input
                disabled={(this.state.isWithSlot && this.state.isTimingDisabled) || this.state.couponApplied}
                className="pay-fields" 
                value={this.state.fields["coupon"]}
                name="coupon"
                onChange={this.handleChange}
                maxLength={100}
                autoComplete='new-password'
                style={{paddingRight: '70px', fontSize: '16px', textTransform: 'uppercase'}}
              />
            </div>
            {this.state.couponApplied && <div style={{color: 'green', fontSize: '11px', marginTop: '3px'}}>
               Coupon applied successfully!
            </div>}
            <button type="button" className={this.state.discountAmount ? 'coupon-apply c-a-blk' : 'coupon-apply'} onClick={this.validateCoupon.bind(this)}>{this.state.discountAmount ? 'Remove' : 'Apply'}</button>
          </div>
          <div style={{display: isPayment ? 'block' : 'none'}}>
            <h4 style={{paddingTop: 20, paddingBottom: 10}}>Payment</h4>
            <div style={{display: 'none'}} id='partners-button'>
              <div>
                <div style={{width: '150px'}}>
                <div id="payment-request-button"></div>
                </div>
              </div>
              <div class="separator">
                <div class="line"></div>
                <h6> or pay using your card </h6>
                <div class="line"></div>
              </div>
            </div>
            
            <div className="card-info-nmi">
              <CollectJSSection data={this.state}/>
            </div>
            <div className="error-msg">{this.state.errors['card_details']}</div>
            <div class="group">
              <label>
                <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
              </label>
            </div>    
            <div style={{paddingLeft: '15px', marginTop: '4px'}} className="error-msg">{this.state.errors['cardholder_name']}</div> 
          </div>
          {this.env != 'PROD' && <div><label style={{fontSize: '13px'}} id="register" for="register-checkbox"><input onClick={this.handleProfile.bind(this)} checked={this.state.isSaveProfile} id="register-checkbox" name="register" type="checkbox" /> Save profile information for future bookings</label></div>}
          <p style={{paddingTop: '10px'}}>If you stay for more than 15 minutes after the expiration of your parking reservation, we will charge your card for the next time period.</p>
          <p style={{paddingTop: '10px'}}>There are no cancellations and refunds possible.</p>
          <button onClick={this.preSubmit.bind(this)} id="pay-submit" type="button">{isPayment ? 'Pay ' + (this.state.totalFee > -1 ? `$${(this.state.totalFee/100).toFixed(2)}` : '') : 'Make Reservation'}</button>
          <div style={{clear: 'both'}} />
          <p style={{padding: '10px 0'}}>For Extensions, Reservations, Assistance and Booking History, Download our App</p>
          <div className="download-app">
            <a target="_blank" href="https://apps.apple.com/in/app/parkquility/id1543951488"><img src={iosIcon} /></a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.parkquility"><img src={googleIcon} /></a>
            <div style={{clear: 'both'}}></div>
          </div>
          <div className="outcome">
            <div className="error" />
            <div className="success">
              Success! Your Stripe token is <span className="token" />
            </div>
          </div>
          <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
        </form>
      </div>      
    )
  }
}
